import { setParamIfDefined, setParamIfUndefined, toUrl } from "../utils.js";
export const parse = url => {
  const parsed = toUrl(url);
  const width = Number(parsed.searchParams.get("w")) || undefined;
  const height = Number(parsed.searchParams.get("h")) || undefined;
  const quality = Number(parsed.searchParams.get("q")) || undefined;
  const format = parsed.searchParams.get("fm") || undefined;
  const params = {};
  parsed.searchParams.forEach((value, key) => {
    params[key] = value;
  });
  parsed.search = "";
  return {
    base: parsed.toString(),
    width,
    height,
    quality,
    format,
    params,
    cdn: "imgix"
  };
};
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height,
    format
  } = _ref;
  const url = toUrl(originalUrl);
  setParamIfDefined(url, "w", width, true, true);
  setParamIfDefined(url, "h", height, true, true);
  setParamIfUndefined(url, "fit", "min");
  if (format) {
    url.searchParams.set("fm", format);
    const fm = url.searchParams.get("auto");
    if (fm === "format") {
      url.searchParams.delete("auto");
    } else if (fm !== null && fm !== void 0 && fm.includes("format")) {
      url.searchParams.set("auto", fm.split(",").filter(s => s !== "format").join(","));
    }
  } else {
    var _url$searchParams$get;
    url.searchParams.delete("fm");
    if (!((_url$searchParams$get = url.searchParams.get("auto")) !== null && _url$searchParams$get !== void 0 && _url$searchParams$get.includes("format"))) {
      url.searchParams.append("auto", "format");
    }
  }
  return url;
};